import Cookie from "react-cookies";

// handler to check if token is expired then to remove token and logout user automatically
export const tokenExpired = (message, navigate) => {
  if (message === "Invalid token.") {
    Cookie.remove("token");
    navigate("/login");
  }
};
